module.exports = __webpack_public_path__ + "img/low_car.1d411ef7.svg";